/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CommentRectXIcon24Solid = forwardRef('CommentRectXIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 7a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-5.182l-4.43 3.25C7.395 22.976 6 22.268 6 21.04V19a4 4 0 0 1-4-4V7Zm13.716 1.709a1 1 0 0 0-1.414-1.414l-2.299 2.298-2.298-2.298a1 1 0 0 0-1.414 1.414l2.298 2.298-2.298 2.298a1 1 0 1 0 1.414 1.414l2.298-2.298 2.299 2.298a1 1 0 1 0 1.414-1.414l-2.298-2.298 2.298-2.298Z" })));
});
